//This treatment data service will limit the amount of repetitive calls we make to the treatment collection. 
//So this will include:
//adding a treatment, getting a treatment list, upvoting a treatment, commenting on a treatment
import firebase from '@/fb'; 
import fbAdmin from 'firebase';
// Instantiate an Algolia client
import { algoliaConfig } from '../../algolia/algoliaConfig.js';
const algoliasearch = require('algoliasearch');
const algoliaClient = algoliasearch(algoliaConfig.ALGOLIA_APP_ID, algoliaConfig.ALGOLIA_API_KEY);

export default class TreatmentDataService {
    constructor(userDb){
        //Only the userDb should be required, from here we'd be able to get all of the needed info. Just each method/function would pass in the relative treatmentID etc.
        this.userDb = userDb;
    }

    // setupAlgoliaSearch() {
    //     let bundle = Bundle.main.bundleIdentifier else { return }
    //     let searchClient = Client(appID: "", apiKey: "")
    //     let indexName = bundle == "YOUR_PRODUCTION_BUNDLE" ? "COLLECTION_prod" : "COLLECTION_dev"
    //     collectionIndex = searchClient.index(withName: indexName)
    //     query.hitsPerPage = 20
        
    //     // Limiting the attributes to be retrieved helps reduce response size and improve performance.
    //     query.attributesToRetrieve = ["property1", "property2", "property3"]
    //     query.attributesToHighlight = ["property1", "property2", "property3"]
    // }

    async searchAlgoliaByString(searchString){
        const { requests } = searchString;
        
        const results = await algoliaClient.search(requests);

        return results;
    }

    async searchFirebaseById(collection, id){
        return new Promise(function(resolve, reject){
            var docRef = firebase.db.collection(collection).doc(id);

            docRef.get().then(function(doc) {
                if (doc.exists) {
                    resolve({id: doc.id, data: doc.data()});
                } else {
                    resolve(null);
                }
            }).catch(function(){
                reject(null);
            })
        })   
    }

    async updateFirebaseById(collection, id, updateObject){
        return new Promise(function(resolve, reject){
            firebase.db
            .collection(collection)
            .doc(id)
            .update(updateObject)
            .then(function(){
                resolve(`${collection} successfully updated`); // eslint-disable-line no-console
            })
            .catch(function(error){
                reject("Error updating the image storage references: " + error); // eslint-disable-line no-console
            })
        })
    }

    async deleteTreatmentById(id){
        return new Promise(function(resolve, reject){
            //We don't actually modify the information in the case, as if this information is missing we'll have a notice that it was deleted
            firebase.db.collection('treatments').doc(id).delete().then(function() {
                resolve("Treatment successfully deleted!");
            }).catch(function(error) {
                reject("Error removing document: ", error);
            }); 
        });
            //REMEMBER TO PUT SOME MANAGEMENT ON THE VIEW CASE TREATMENT TABS IF THE TREATMENT NO LONGER EXISTS
    }

    async deleteCaseById(id, treatmentIds){
        var that = this;
        return new Promise(function(resolve, reject){
            //First get the case, then the treatment ids involved in this case (maybe we just pass these straight in as part of deleting a case)
            treatmentIds.forEach(async function (treatmentId){
                await that.searchFirebaseById('treatments', treatmentId)
                .then(function(treatment){
                    var treatmentData = treatment.data;

                    if (treatmentData.case.value) {
                        var updateObject = {};
                        if (treatmentData.case.parentCases.length > 1) {
                            const indexPosition = treatmentData.case.parentCases.indexOf(id);
                            var updatedCaseList = treatmentData.case.parentCases.splice(indexPosition, 1);
    
                            //After the index position where that case id is located is removed, update the case list
                            updateObject = { case: { value: true, parentCases: [updatedCaseList] } };
                        } else {
                            //Update Object will not need any array
                            updateObject = { case: { value: false, parentCases: [] } };
                        }
                        
                        //Safely update the object
                        that.updateFirebaseById('treatments', treatmentId, updateObject)
                        .then(function (){
                            //If the treatment was successfully updated, then we can now remove the case
                            firebase.db.collection('cases').doc(id).delete().then(function() {
                                resolve("Successfully deleted the case");
                            }).catch(function(error) {
                                reject("Error removing document: ", error); 
                            });        
                        }).catch(function(error){
                            //There was an error in updating so we are not able to remove the case
                            reject("Error deleting the case: " + error);
                        });
                    } else {
                        //If the treatment was successfully updated, then we can now remove the case <--- SHOULD PUT THIS STRAIGHT INTO A FUNCTION
                        firebase.db.collection('cases').doc(id).delete().then(function() {
                            resolve("Successfully deleted the case");
                        }).catch(function(error) {
                            reject("Error removing document: ", error); 
                        });   
                    }
                }).catch(function(error){
                    //There was an error in updating so we are not able to remove the case
                    reject("Error deleting the case: " + error);
                });
            });   
        });
    }

    async getList(org, orgId, isPublic, category, orderBy, limit, collection){
        var items = [];

        var collectionRef;
        if (org){
            collectionRef = firebase.db.collection(collection).where("organisation", "==", orgId);
        } else {
            collectionRef = firebase.db.collection(collection);
        }

        if (isPublic){
            collectionRef = collectionRef.where("public", "==", true);
        }

        //If the treatment list is unique to a particular category
        if (category){
            collectionRef = collectionRef.where("category", "array-contains-any", category);
        }

        
        if (orderBy == "Newest")
        {
            //Order by newest (may need to add timestamps for this or change the date format)

        } else if (orderBy == "Upvotes") {
            //Order by upvotes/most popular
            //*It sorts by ascending order by default, so we set to 'desc'
            collectionRef = collectionRef.orderBy("upvotes", "desc");
        }

        //If we have a limit value that is greater than 0 add a 'limit' to the collectionRef
        //0 = non capped
        if (limit > 0){
            collectionRef = collectionRef.limit(limit);
        }

        collectionRef
        .onSnapshot(res => {
            const changes = res.docChanges();

            changes.forEach(change => {
                if (change.type === 'added'){
                    items.push({id: change.doc.id, data: change.doc.data()}); //Do we need a spread operator here?
                }
            })
        })
        return items;
    }

    //Based on the collection, filterOptions and last parameters, we will construct a query string to get the next page in the pagination
    nextPaginatedPage(collection, collectionLevelSelected, filterOptions, last) {
        return new Promise((resolve, reject) => {
            //Construct filter query
            const collectionRef = this.constructQuery(collection, collectionLevelSelected, filterOptions);

            collectionRef.reference.startAfter(last).limitToLast(filterOptions.pageSize).get()
            .then((snapshot) => {
                var treatmentSnapshots = [];
                if(snapshot.size > 0) {
                    snapshot.forEach(doc => {
                        treatmentSnapshots.push(doc);
                    });
                    resolve(treatmentSnapshots);
                } else {
                    throw new Error(collection + " documents do not exist");
                }
            })
            .catch((error) => {
                reject(error)
            });
        });
    }
    //Based on the collection, filterOptions and first parameters, we will construct a query string to get the previous page in the pagination
    prevPaginatedPage(collection, collectionLevelSelected, filterOptions, first) {
        return new Promise((resolve, reject) => {
            //Construct filter query
            const collectionRef = this.constructQuery(collection, collectionLevelSelected, filterOptions);

            collectionRef.reference.endBefore(first).limitToLast(filterOptions.pageSize).get()
            .then((snapshot) => {
                var treatmentSnapshots = [];
                if(snapshot.size > 0) {
                    snapshot.forEach(doc => {
                        treatmentSnapshots.push(doc);
                    });
                    resolve(treatmentSnapshots);
                } else {
                    throw new Error(collection + " documents do not exist");
                }
            })
            .catch((error) => {
                reject(error)
            });
        });
    }
    //Based on the paginated queries that have been generated, get the documents and return them in the correct format
    firstPaginatedPage(collection, collectionLevelSelected, filterOptions){
        return new Promise((resolve, reject) => {
            //Construct filter query
            const collectionRef = this.constructQuery(collection, collectionLevelSelected, filterOptions);

            collectionRef.reference.limit(filterOptions.pageSize).get()
            .then((snapshot) => {
                var treatmentSnapshots = [];
                if(snapshot.size > 0) {
                    snapshot.forEach(doc => {
                        treatmentSnapshots.push(doc);
                    });
                    resolve(treatmentSnapshots);
                } else {
                    throw new Error(collection + " documents do not exist");
                }
            })
            .catch((error) => {
                reject(error)
            });
        });
    }

    constructQuery(collection, collectionLevelSelected, filterOptions){
        //Construct the base query
        var collectionRef = firebase.db.collection(collection);
        //Is it limited to a particular organisation or individual
        if (collectionLevelSelected === "Personal"){
            collectionRef = collectionRef.where("owner", "==", filterOptions.owner);
        } else if(collectionLevelSelected === "Organisation"){
            collectionRef = collectionRef.where("organisation", "==", filterOptions.organisation);
        }

        //Are we only showing publicly visible ones?
        if (filterOptions.isPublic){
            collectionRef = collectionRef.where("public", "==", true);
        }

        //Are we only looking at the users favourite treatments? https://trello.com/c/g2sw0QJw
        // if (filterOptions.favourites) {
        //     if (filterOptions.favourites.flag) {
        //         if (filterOptions.favourites.items.length) {
        //             //Favourites is now an array, do a .contains with the id's
        //             collectionRef = collectionRef.where(fbAdmin.firestore.FieldPath.documentId(), 'in', filterOptions.favourites.items); //Cannot use two of these, whats the alternate?
        //         }
        //     }
        // }

        //If the treatment list is unique to a particular category
        if (filterOptions.categories.length > 0){
            collectionRef = collectionRef.where("category", "array-contains-any", filterOptions.categories); //May need to add a limit of 10 for frontend category selection
        }

        //Do we have a sort filter?
        var sortByField = "title";
        if (filterOptions.sortBy){
            if (filterOptions.sortBy == "Newest") {
                //Order by newest
                collectionRef = collectionRef.orderBy("dateAddedTimestamp", "desc");
                sortByField = "dateAddedTimestamp";
    
            } else  if (filterOptions.sortBy == "Recently Updated") {
                //Order by the most recently modified
                collectionRef = collectionRef.orderBy("lastModifiedTimestamp", "desc");
                sortByField = "lastModifiedTimestamp";
    
            } else if (filterOptions.sortBy == "Most Popular") {
                //Order by upvotes/most popular
                //*It sorts by ascending order by default, so we set to 'desc'
                collectionRef = collectionRef.orderBy("upvotes", "desc");
                sortByField = "upvotes";
            } else if (filterOptions.sortBy == "A-Z Ascending") {
                //Order by alphabet ascending
                //*It sorts by ascending order by default
                collectionRef = collectionRef.orderBy("title");
                sortByField = "title";
            } else if (filterOptions.sortBy == "A-Z Descending") {
                //Order by alphabet descending
                //*It sorts by ascending order by default, so we set to 'desc'
                collectionRef = collectionRef.orderBy("title", "desc");
                sortByField = "title";
            }
        }

        return {reference: collectionRef, sortByField: sortByField};
    }

    //The getListByIds should allow for specific cases/treatments to be selected/loaded in
    //To stop this taking forever requesting on at a time, we load the treatments in parallel as opposed to sequentially
    async getListByIds(ids, orderBy, collection){
        return new Promise(function (resolve, reject){
            var collectionRef = firebase.db.collection(collection);
            //Promise.all will reject all if one fails, so allows to load sequentially but waits until all are done before actioning
            Promise.all(
                ids.map(function(id){
                    return collectionRef.doc(id).get().then(function(doc){
                        if (doc.exists){
                            return { id: doc.id, data: doc.data() };
                        } else {
                            reject("Id: " + id + "does not exist");
                        }
                    });
                })
            ).then(function (list){
                //If all promises/queries successful, return our grabbed list
                resolve(list);
            }).catch(function(error){
                reject(error);
            })
        })
    }

    //Used for getting a random case or treatment for 'Discover' feature, intend for this to be as agnostic as possible
    async getRandomByInterests(collection, interests, limit, currentIdList) {
        return new Promise((resolve, reject) => {  
            var that = this;
            
            var reference = firebase.db.collection(collection);
            var randomReference = reference;
            if (interests.length > 0) {
                randomReference = reference.where('category', 'array-contains-any', interests)
            }

            var randomKey = reference.doc().id;

            var documents = [];

            //Check for the closest match the the randomKey we generated
            randomReference.where(fbAdmin.firestore.FieldPath.documentId(), '>=', randomKey).limit(limit).get()
            .then(snapshot => {
                if(snapshot.size > 0) {
                    snapshot.forEach(doc => {
                       documents.push({id: doc.id, data: doc.data()});
                       
                       //Exclude the ids already in our list
                       documents = that.excludeDuplicateIds(documents, currentIdList);
                       if (documents.length > 2){
                           return resolve(documents); //Use return resolve to exit code execution
                       }
                    });
                }
                
                //If the first search doesn't work --> reverse the search
                randomReference.where(fbAdmin.firestore.FieldPath.documentId(), '<', randomKey).limit(limit).get()
                .then(snapshot => {
                    if(snapshot.size > 0) {
                        snapshot.forEach(doc => {
                            documents.push({id: doc.id, data: doc.data()});

                            //Exclude the ids already in our list
                            documents = that.excludeDuplicateIds(documents, currentIdList);
                            if (documents.length > 2) {
                                return resolve(documents); //Use return resolve to exit code execution
                            }
                        });
                    } 

                    //If we still can't find anything, then remove the reference and try again (this is only worth attempting if we were using the interests in the first place)
                    if (interests.length > 0) {
                        reference.where(fbAdmin.firestore.FieldPath.documentId(), '>=', randomKey).limit(limit).get()
                        .then(snapshot => {
                            if(snapshot.size > 0) {
                                snapshot.forEach(doc => {
                                    documents.push({id: doc.id, data: doc.data()});

                                    //Exclude the ids already in our list
                                    documents = that.excludeDuplicateIds(documents, currentIdList);
                                    if (documents.length > 2) {
                                        return resolve(documents); //Use return resolve to exit code execution
                                    }
                                });
                            }

                            //If the first search doesn't work --> reverse the search
                            reference.where(fbAdmin.firestore.FieldPath.documentId(), '<', randomKey).limit(limit).get()
                            .then(snapshot => {
                                if(snapshot.size > 0) {
                                    snapshot.forEach(doc => {
                                        documents.push({id: doc.id, data: doc.data()});

                                        //Exclude the ids already in our list
                                        documents = that.excludeDuplicateIds(documents, currentIdList);
                                        if (documents.length > 2) {
                                            return resolve(documents); //Use return resolve to exit code execution
                                        }
                                    });
                                } else {
                                    if (documents.length > 0){
                                        return resolve(documents);
                                    }
                                    reject("Could not find any documents");
                                }
                            });
                        });
                    } else {
                        if (documents.length > 0){
                            //Just return whatever documents we have
                            return resolve (documents);
                        }
                        reject("Could not find any documents");
                    }
                })
                .catch(err => {
                    reject('Error getting documents', err);
                    console.log('Error getting documents inner', err); //eslint-disable-line
                });
            })
            .catch(err => {
                reject('Error getting documents', err);
                console.log('Error getting documents outer', err); //eslint-disable-line
            });
        })        
    }

    excludeDuplicateIds(documents, currentIdList){
        //Exclude the ids that are included in the currentIdList
        return documents.filter(function(doc){
            return !currentIdList.includes(doc.id);
        });
    }
}